import React, { useEffect, useState } from "react";
import CounterAreaItem from "./CounterAreaItem";

const CounterArea = () => {
  const [amount, setAmount] = useState(210);

  useEffect(() => {
    const timer = setInterval(() => {
      if (parseFloat(amount) < 999) {
        const newNumber = parseFloat(amount) + 10;

        setAmount(newNumber);
      }
    }, 1000 * 10);

    return () => {
      clearInterval(timer);
    };
  }, [amount]);

  return (
    <section className="counter-area">
      <div className="container custom-container-four">
        <div className="counter-inner">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6">
              <CounterAreaItem
                amount={6200}
                title="   Utenti Discord"
                undertitle="Più di"
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <CounterAreaItem
                amount={3200}
                title="Player Whitelistati"
                undertitle="Più di"
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <CounterAreaItem
                amount={200}
                title="Slot nel Server"
                undertitle="ㅤ"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterArea;
